export class ApplicationUser {
    /**
     * Application User View Model.
     */
    constructor(
        public hawkId: string = '',
        public roles: string[] = []
    ) {
    }

    isAuthenticated(): boolean {
        return !!this.hawkId;
    }

    isBasicUser(): boolean {
        return this.roles.indexOf('BasicUser') !== -1;
    }

    isAdmin(): boolean {
        return this.roles.indexOf('Admin') !== -1;
    }

    isPrimaryContact(): boolean {
        return this.roles.indexOf('PrimaryContact') !== -1;
    }
}
